const ZH = {
  Search: "\u641C\u7D22",
  Streams: "\u65E5\u5FD7\u6D41",
  Alerts: "\u544A\u8B66",
  Dashboards: "\u4EEA\u8868\u76D8",
  Dashboard: "\u4EEA\u8868\u76D8",
  System: "\u7CFB\u7EDF",
  Enterprise: "\u4F01\u4E1A\u7248",
  Security: "\u5B89\u5168",
  Overview: "\u6982\u89C8",
  Configurations: "\u914D\u7F6E",
  Configuration: "\u914D\u7F6E",
  "Cluster Configuration": "\u96C6\u7FA4\u914D\u7F6E",
  Inputs: "\u8F93\u5165",
  Input: "\u8F93\u5165",
  Outputs: "\u8F93\u51FA",
  Indices: "\u7D22\u5F15",
  "Indices and Index Sets": "\u7D22\u5F15\u548C\u7D22\u5F15\u96C6",
  "Indices & Index Sets": "\u7D22\u5F15\u548C\u7D22\u5F15\u96C6",
  "Users Overview": "\u7528\u6237",
  "Index Set Field Type Profiles": "\u7D22\u5F15\u96C6\u5B57\u6BB5\u7C7B\u578B",
  "Index Set Templates": "\u7D22\u5F15\u96C6\u6A21\u677F",
  "Index Rotation Configuration": "\u7D22\u5F15\u8F6E\u8F6C\u914D\u7F6E",
  "Index Retention Configuration": "\u7D22\u5F15\u4FDD\u7559\u914D\u7F6E",
  "Indexer failures": "\u7D22\u5F15\u5931\u8D25",
  "Index/Message not found": "\u627E\u4E0D\u5230\u7D22\u5F15\u6216\u6D88\u606F",
  "Index Set": "\u7D22\u5F15\u96C6",
  "Index Sets": "\u7D22\u5F15\u96C6",
  Logging: "\u65E5\u5FD7\u7EA7\u522B",
  "Users and Teams": "\u7528\u6237\u548C\u56E2\u961F",
  Users: "\u7528\u6237",
  User: "\u7528\u6237",
  Teams: "\u56E2\u961F",
  Roles: "\u89D2\u8272",
  Role: "\u89D2\u8272",
  Authentication: "\u8BA4\u8BC1",
  "Content Packs": "\u5185\u5BB9\u5305",
  "Content packs": "\u5185\u5BB9\u5305",
  "Grok Patterns": "Grok \u6A21\u5F0F",
  "Lookup Tables": "\u67E5\u627E\u8868",
  Pipelines: "\u7BA1\u9053",
  Sidecars: "\u91C7\u96C6\u7AEF",
  Collectors: "\u91C7\u96C6\u5668",
  Documentation: "\u6587\u6863",
  "Keyboard Shortcuts": "\u5FEB\u6377\u952E",
  "API browser": "\u63A5\u53E3\u6D4F\u89C8\u5668",
  "Design System": "\u8BBE\u8BA1\u7CFB\u7EDF",
  Username: "\u7528\u6237\u540D",
  Password: "\u5BC6\u7801",
  "Sign in": "\u767B\u5F55",
  "Signing in...": "\u6B63\u5728\u767B\u5F55...",
  "Log out": "\u9000\u51FA\u767B\u5F55",
  Logout: "\u9000\u51FA\u767B\u5F55",
  "Edit profile": "\u7F16\u8F91\u8D44\u6599",
  "Show profile": "\u67E5\u770B\u8D44\u6599",
  "Welcome to Graylog": "\u6B22\u8FCE\u4F7F\u7528\u798F\u5229\u5546\u57CE\u65E5\u5FD7\u5E73\u53F0",
  "Welcome to Graylog!": "\u6B22\u8FCE\u4F7F\u7528\u798F\u5229\u5546\u57CE\u65E5\u5FD7\u5E73\u53F0",
  Welcome: "\u6B22\u8FCE",
  "Last Opened": "\u6700\u8FD1\u6253\u5F00",
  "Favorite Items": "\u6536\u85CF",
  "Recent Activity": "\u6700\u8FD1\u52A8\u6001",
  News: "\u65B0\u95FB",
  Releases: "\u7248\u672C",
  Close: "\u5173\u95ED",
  Save: "\u4FDD\u5B58",
  "Save as": "\u53E6\u5B58\u4E3A",
  Saved: "\u5DF2\u4FDD\u5B58",
  Cancel: "\u53D6\u6D88",
  Create: "\u65B0\u5EFA",
  Delete: "\u5220\u9664",
  Edit: "\u7F16\u8F91",
  Update: "\u66F4\u65B0",
  Submit: "\u63D0\u4EA4",
  Reset: "\u91CD\u7F6E",
  Apply: "\u5E94\u7528",
  Export: "\u5BFC\u51FA",
  Share: "\u5206\u4EAB",
  More: "\u66F4\u591A",
  "More actions": "\u66F4\u591A\u64CD\u4F5C",
  Actions: "\u64CD\u4F5C",
  Action: "\u64CD\u4F5C",
  Add: "\u6DFB\u52A0",
  Remove: "\u79FB\u9664",
  Confirm: "\u786E\u8BA4",
  Yes: "\u662F",
  No: "\u5426",
  OK: "\u786E\u5B9A",
  Back: "\u8FD4\u56DE",
  Next: "\u4E0B\u4E00\u6B65",
  Previous: "\u4E0A\u4E00\u6B65",
  Done: "\u5B8C\u6210",
  Loading: "\u52A0\u8F7D\u4E2D",
  "Loading...": "\u52A0\u8F7D\u4E2D...",
  "Please wait": "\u8BF7\u7A0D\u5019",
  "No results found": "\u6CA1\u6709\u627E\u5230\u7ED3\u679C",
  "No results": "\u6CA1\u6709\u7ED3\u679C",
  "Not found": "\u672A\u627E\u5230",
  Name: "\u540D\u79F0",
  Title: "\u6807\u9898",
  Description: "\u63CF\u8FF0",
  Type: "\u7C7B\u578B",
  Status: "\u72B6\u6001",
  State: "\u72B6\u6001",
  Created: "\u521B\u5EFA\u65F6\u95F4",
  Updated: "\u66F4\u65B0\u65F6\u95F4",
  Owner: "\u6240\u6709\u8005",
  Permissions: "\u6743\u9650",
  Enabled: "\u5DF2\u542F\u7528",
  Disabled: "\u5DF2\u505C\u7528",
  Running: "\u8FD0\u884C\u4E2D",
  Failed: "\u5931\u8D25",
  Stopped: "\u5DF2\u505C\u6B62",
  Starting: "\u542F\u52A8\u4E2D",
  Setup: "\u8BBE\u7F6E",
  Details: "\u8BE6\u60C5",
  Settings: "\u8BBE\u7F6E",
  General: "\u5E38\u89C4",
  Advanced: "\u9AD8\u7EA7",
  Filter: "\u7B5B\u9009",
  Filters: "\u7B5B\u9009",
  "Add filter": "\u6DFB\u52A0\u7B5B\u9009",
  Query: "\u67E5\u8BE2",
  "Time Range": "\u65F6\u95F4\u8303\u56F4",
  "Time range": "\u65F6\u95F4\u8303\u56F4",
  Relative: "\u76F8\u5BF9\u65F6\u95F4",
  Absolute: "\u7EDD\u5BF9\u65F6\u95F4",
  Keyword: "\u5173\u952E\u5B57",
  Preset: "\u9884\u8BBE",
  Presets: "\u9884\u8BBE",
  "All Time": "\u5168\u90E8\u65F6\u95F4",
  "All time": "\u5168\u90E8\u65F6\u95F4",
  "All messages": "\u5168\u90E8\u6D88\u606F",
  From: "\u5F00\u59CB",
  To: "\u7ED3\u675F",
  Now: "\u73B0\u5728",
  Today: "\u4ECA\u5929",
  Yesterday: "\u6628\u5929",
  Messages: "\u6D88\u606F",
  Message: "\u6D88\u606F",
  Fields: "\u5B57\u6BB5",
  Field: "\u5B57\u6BB5",
  Values: "\u53D6\u503C",
  Statistics: "\u7EDF\u8BA1",
  Histogram: "\u67F1\u72B6\u56FE",
  Sidebar: "\u4FA7\u680F",
  Widgets: "\u7EC4\u4EF6",
  Widget: "\u7EC4\u4EF6",
  "Add widget": "\u6DFB\u52A0\u7EC4\u4EF6",
  Aggregation: "\u805A\u5408",
  "Message Table": "\u6D88\u606F\u8868",
  "Message table": "\u6D88\u606F\u8868",
  "Message Count": "\u6D88\u606F\u6570\u91CF",
  "Perform Search": "\u6267\u884C\u641C\u7D22",
  "Perform search (changes were made after last search execution)": "\u6267\u884C\u641C\u7D22\uFF08\u4E0A\u6B21\u641C\u7D22\u540E\u67E5\u8BE2\u5DF2\u4FEE\u6539\uFF09",
  'Type your search query here and press enter. E.g.: ("not found" AND http) OR http_response_code:[400 TO 404]': '\u8F93\u5165\u67E5\u8BE2\u540E\u56DE\u8F66\u3002\u4F8B\u5982\uFF1A("not found" AND http) OR http_response_code:[400 TO 404]',
  Timestamp: "\u65F6\u95F4",
  Source: "\u6765\u6E90",
  "Load more": "\u52A0\u8F7D\u66F4\u591A",
  Refresh: "\u5237\u65B0",
  "Auto refresh": "\u81EA\u52A8\u5237\u65B0",
  "Undo": "\u64A4\u9500",
  Redo: "\u91CD\u505A",
  "Replay search": "\u91CD\u653E\u641C\u7D22",
  "Saved searches": "\u5DF2\u4FDD\u5B58\u7684\u641C\u7D22",
  "Saved search": "\u5DF2\u4FDD\u5B58\u7684\u641C\u7D22",
  "New search": "\u65B0\u5EFA\u641C\u7D22",
  "Save search": "\u4FDD\u5B58\u641C\u7D22",
  "Export results": "\u5BFC\u51FA\u7ED3\u679C",
  Decorators: "\u88C5\u9970\u5668",
  Sort: "\u6392\u5E8F",
  Direction: "\u65B9\u5411",
  Ascending: "\u5347\u5E8F",
  Descending: "\u964D\u5E8F",
  Page: "\u9875",
  of: "\u5171",
  "Rows per page": "\u6BCF\u9875\u884C\u6570",
  "per page": "\u6BCF\u9875",
  Show: "\u663E\u793A",
  Hide: "\u9690\u85CF",
  Expand: "\u5C55\u5F00",
  Collapse: "\u6536\u8D77",
  Copy: "\u590D\u5236",
  Copied: "\u5DF2\u590D\u5236",
  Download: "\u4E0B\u8F7D",
  Upload: "\u4E0A\u4F20",
  Import: "\u5BFC\u5165",
  "Select all": "\u5168\u9009",
  Selected: "\u5DF2\u9009\u62E9",
  None: "\u65E0",
  All: "\u5168\u90E8",
  Any: "\u4EFB\u610F",
  Unknown: "\u672A\u77E5",
  Error: "\u9519\u8BEF",
  Warning: "\u8B66\u544A",
  Info: "\u4FE1\u606F",
  Success: "\u6210\u529F",
  Notifications: "\u901A\u77E5",
  Notification: "\u901A\u77E5",
  "No unread system notifications": "\u6CA1\u6709\u672A\u8BFB\u7CFB\u7EDF\u901A\u77E5",
  "System notifications": "\u7CFB\u7EDF\u901A\u77E5",
  Profile: "\u8D44\u6599",
  "Light mode": "\u6D45\u8272",
  "Dark mode": "\u6DF1\u8272",
  Theme: "\u4E3B\u9898",
  "Full name": "\u59D3\u540D",
  "Email address": "\u90AE\u7BB1",
  Email: "\u90AE\u7BB1",
  "Time zone": "\u65F6\u533A",
  Timezone: "\u65F6\u533A",
  "Session timeout": "\u4F1A\u8BDD\u8D85\u65F6",
  "Start page": "\u8D77\u59CB\u9875",
  "Change password": "\u4FEE\u6539\u5BC6\u7801",
  "Old password": "\u539F\u5BC6\u7801",
  "New password": "\u65B0\u5BC6\u7801",
  "Repeat password": "\u786E\u8BA4\u5BC6\u7801",
  "Create user": "\u65B0\u5EFA\u7528\u6237",
  "Edit user": "\u7F16\u8F91\u7528\u6237",
  "Delete user": "\u5220\u9664\u7528\u6237",
  "Create stream": "\u65B0\u5EFA\u65E5\u5FD7\u6D41",
  "Edit stream": "\u7F16\u8F91\u65E5\u5FD7\u6D41",
  "Delete stream": "\u5220\u9664\u65E5\u5FD7\u6D41",
  "Manage rules": "\u7BA1\u7406\u89C4\u5219",
  "Stream rules": "\u65E5\u5FD7\u6D41\u89C4\u5219",
  Rules: "\u89C4\u5219",
  Rule: "\u89C4\u5219",
  "Paused": "\u5DF2\u6682\u505C",
  Pause: "\u6682\u505C",
  Resume: "\u6062\u590D",
  Start: "\u542F\u52A8",
  Stop: "\u505C\u6B62",
  Throughput: "\u541E\u5410",
  "Index rotation": "\u7D22\u5F15\u8F6E\u8F6C",
  "Index retention": "\u7D22\u5F15\u4FDD\u7559",
  Rotation: "\u8F6E\u8F6C",
  Retention: "\u4FDD\u7559",
  Shards: "\u5206\u7247",
  Replicas: "\u526F\u672C",
  Size: "\u5927\u5C0F",
  Documents: "\u6587\u6863\u6570",
  Health: "\u5065\u5EB7",
  Green: "\u6B63\u5E38",
  Yellow: "\u8B66\u544A",
  Red: "\u5F02\u5E38",
  Nodes: "\u8282\u70B9",
  Node: "\u8282\u70B9",
  "Processing": "\u5904\u7406\u4E2D",
  "Journal": "\u65E5\u5FD7\u7F13\u51B2",
  "Message processors": "\u6D88\u606F\u5904\u7406\u5668",
  Extractors: "\u63D0\u53D6\u5668",
  "Static fields": "\u9759\u6001\u5B57\u6BB5",
  "Global": "\u5168\u5C40",
  "Bind address": "\u7ED1\u5B9A\u5730\u5740",
  Port: "\u7AEF\u53E3",
  "Receive buffer size": "\u63A5\u6536\u7F13\u51B2\u533A",
  "Launch new input": "\u65B0\u5EFA\u8F93\u5165",
  "Edit input": "\u7F16\u8F91\u8F93\u5165",
  "Stop input": "\u505C\u6B62\u8F93\u5165",
  "Start input": "\u542F\u52A8\u8F93\u5165",
  "Delete input": "\u5220\u9664\u8F93\u5165",
  "Show received messages": "\u67E5\u770B\u6536\u5230\u7684\u6D88\u606F",
  "Manage extractors": "\u7BA1\u7406\u63D0\u53D6\u5668",
  Required: "\u5FC5\u586B",
  Optional: "\u53EF\u9009",
  "This field is required": "\u6B64\u9879\u5FC5\u586B",
  "Invalid value": "\u53D6\u503C\u65E0\u6548",
  "Are you sure?": "\u786E\u5B9A\u8981\u7EE7\u7EED\u5417\uFF1F",
  "This action cannot be undone.": "\u6B64\u64CD\u4F5C\u65E0\u6CD5\u64A4\u9500\u3002",
  "No data available": "\u6682\u65E0\u6570\u636E",
  "Nothing found": "\u6CA1\u6709\u627E\u5230\u5185\u5BB9",
  "Try again": "\u91CD\u8BD5",
  Retry: "\u91CD\u8BD5",
  Help: "\u5E2E\u52A9",
  About: "\u5173\u4E8E",
  Version: "\u7248\u672C",
  License: "\u8BB8\u53EF\u8BC1",
  "Cluster ID": "\u96C6\u7FA4\u7F16\u53F7",
  "Node ID": "\u8282\u70B9\u7F16\u53F7",
  Hostname: "\u4E3B\u673A\u540D",
  "Operating system": "\u64CD\u4F5C\u7CFB\u7EDF",
  "JVM": "JVM",
  "Memory": "\u5185\u5B58",
  "CPU": "CPU",
  Uptime: "\u8FD0\u884C\u65F6\u95F4",
  "Search cluster": "\u641C\u7D22\u96C6\u7FA4",
  Elasticsearch: "Elasticsearch",
  MongoDB: "MongoDB",
  "Open search": "\u6253\u5F00\u641C\u7D22",
  "New dashboard": "\u65B0\u5EFA\u4EEA\u8868\u76D8",
  "Create dashboard": "\u65B0\u5EFA\u4EEA\u8868\u76D8",
  "Edit dashboard": "\u7F16\u8F91\u4EEA\u8868\u76D8",
  "Dashboard list": "\u4EEA\u8868\u76D8\u5217\u8868",
  "Add to dashboard": "\u6DFB\u52A0\u5230\u4EEA\u8868\u76D8",
  "Widget query": "\u7EC4\u4EF6\u67E5\u8BE2",
  "Row limit": "\u884C\u6570\u4E0A\u9650",
  "Show columns": "\u663E\u793A\u5217",
  "Field name": "\u5B57\u6BB5\u540D",
  "Field type": "\u5B57\u6BB5\u7C7B\u578B",
  "Field value": "\u5B57\u6BB5\u503C",
  "Add to query": "\u52A0\u5165\u67E5\u8BE2",
  "Exclude from query": "\u4ECE\u67E5\u8BE2\u4E2D\u6392\u9664",
  "Show top values": "\u663E\u793A\u9AD8\u9891\u53D6\u503C",
  "Statistics of this field": "\u8BE5\u5B57\u6BB5\u7684\u7EDF\u8BA1",
  Chart: "\u56FE\u8868",
  Table: "\u8868\u683C",
  "Data table": "\u6570\u636E\u8868",
  Visualization: "\u53EF\u89C6\u5316",
  "Group by": "\u5206\u7EC4",
  Metric: "\u6307\u6807",
  Metrics: "\u6307\u6807",
  Count: "\u8BA1\u6570",
  Average: "\u5E73\u5747\u503C",
  Sum: "\u5408\u8BA1",
  Min: "\u6700\u5C0F",
  Max: "\u6700\u5927",
  Cardinality: "\u53BB\u91CD\u8BA1\u6570",
  Percentile: "\u767E\u5206\u4F4D",
  StdDev: "\u6807\u51C6\u5DEE",
  Variance: "\u65B9\u5DEE",
  "Latest": "\u6700\u65B0",
  Interval: "\u95F4\u9694",
  Auto: "\u81EA\u52A8",
  Second: "\u79D2",
  Seconds: "\u79D2",
  Minute: "\u5206\u949F",
  Minutes: "\u5206\u949F",
  Hour: "\u5C0F\u65F6",
  Hours: "\u5C0F\u65F6",
  Day: "\u5929",
  Days: "\u5929",
  Week: "\u5468",
  Weeks: "\u5468",
  Month: "\u6708",
  Months: "\u6708",
  Year: "\u5E74",
  Years: "\u5E74",
  ago: "\u524D",
  "Last 5 minutes": "\u6700\u8FD1 5 \u5206\u949F",
  "Last 15 minutes": "\u6700\u8FD1 15 \u5206\u949F",
  "Last 30 minutes": "\u6700\u8FD1 30 \u5206\u949F",
  "Last 1 hour": "\u6700\u8FD1 1 \u5C0F\u65F6",
  "Last 2 hours": "\u6700\u8FD1 2 \u5C0F\u65F6",
  "Last 8 hours": "\u6700\u8FD1 8 \u5C0F\u65F6",
  "Last 1 day": "\u6700\u8FD1 1 \u5929",
  "Last 2 days": "\u6700\u8FD1 2 \u5929",
  "Last 5 days": "\u6700\u8FD1 5 \u5929",
  "Last 7 days": "\u6700\u8FD1 7 \u5929",
  "Last 30 days": "\u6700\u8FD1 30 \u5929",
  "Last 90 days": "\u6700\u8FD1 90 \u5929",
  "Last 6 months": "\u6700\u8FD1 6 \u4E2A\u6708",
  "Search in the last": "\u641C\u7D22\u6700\u8FD1",
  "and the next": "\u4EE5\u53CA\u4E4B\u540E",
  "from now": "\u4ECE\u73B0\u5728\u8D77",
  "Tab: Relative": "\u76F8\u5BF9\u65F6\u95F4",
  "Tab: Absolute": "\u7EDD\u5BF9\u65F6\u95F4",
  "Tab: Keyword": "\u5173\u952E\u5B57",
  "No override": "\u4E0D\u8986\u76D6",
  "Search result is still being computed": "\u6B63\u5728\u8BA1\u7B97\u641C\u7D22\u7ED3\u679C",
  "Search execution failed": "\u641C\u7D22\u6267\u884C\u5931\u8D25",
  "Executing search": "\u6B63\u5728\u641C\u7D22",
  "Updating search": "\u6B63\u5728\u66F4\u65B0\u641C\u7D22",
  "Open sidebar": "\u6253\u5F00\u4FA7\u680F",
  "Close sidebar": "\u5173\u95ED\u4FA7\u680F",
  "Toggle sidebar": "\u5207\u6362\u4FA7\u680F",
  "Full screen": "\u5168\u5C4F",
  "Exit full screen": "\u9000\u51FA\u5168\u5C4F",
  "Copy field value": "\u590D\u5236\u5B57\u6BB5\u503C",
  "Show surrounding messages": "\u67E5\u770B\u524D\u540E\u6D88\u606F",
  "Permalink": "\u56FA\u5B9A\u94FE\u63A5",
  "Test against stream": "\u7528\u65E5\u5FD7\u6D41\u6D4B\u8BD5",
  "Matching type": "\u5339\u914D\u65B9\u5F0F",
  "Match all": "\u5168\u90E8\u5339\u914D",
  "Match any": "\u5339\u914D\u4EFB\u4E00",
  "Remove matches from default stream": "\u4ECE\u9ED8\u8BA4\u6D41\u4E2D\u79FB\u9664\u5DF2\u5339\u914D\u6D88\u606F",
  "Index set": "\u7D22\u5F15\u96C6",
  "Default index set": "\u9ED8\u8BA4\u7D22\u5F15\u96C6",
  Prefix: "\u524D\u7F00",
  "Analyzer": "\u5206\u6790\u5668",
  "Field type refresh interval": "\u5B57\u6BB5\u7C7B\u578B\u5237\u65B0\u95F4\u9694",
  "Rotation strategy": "\u8F6E\u8F6C\u7B56\u7565",
  "Retention strategy": "\u4FDD\u7559\u7B56\u7565",
  "Max number of indices": "\u6700\u5927\u7D22\u5F15\u6570",
  "Rotation period": "\u8F6E\u8F6C\u5468\u671F",
  "Index prefix": "\u7D22\u5F15\u524D\u7F00",
  Writable: "\u53EF\u5199",
  Default: "\u9ED8\u8BA4",
  "Make default": "\u8BBE\u4E3A\u9ED8\u8BA4",
  Recalculate: "\u91CD\u65B0\u8BA1\u7B97",
  "Recalculate index ranges": "\u91CD\u65B0\u8BA1\u7B97\u7D22\u5F15\u8303\u56F4",
  "Cycle deflector": "\u5207\u6362\u5199\u5165\u7D22\u5F15",
  "Index maintenance": "\u7D22\u5F15\u7EF4\u62A4",
  Closed: "\u5DF2\u5173\u95ED",
  Open: "\u6253\u5F00",
  Reopened: "\u5DF2\u91CD\u65B0\u6253\u5F00",
  "Show messages": "\u67E5\u770B\u6D88\u606F",
  "msg/s": "\u6761/\u79D2",
  Administrator: "\u7BA1\u7406\u5458",
  "Read only": "\u53EA\u8BFB",
  "Is admin": "\u7BA1\u7406\u5458",
  "Client address": "\u5BA2\u6237\u7AEF\u5730\u5740",
  "Last activity": "\u6700\u8FD1\u6D3B\u52A8",
  "Session active": "\u4F1A\u8BDD\u6709\u6548",
  "Logged in": "\u5DF2\u767B\u5F55",
  "External user": "\u5916\u90E8\u7528\u6237",
  "First name": "\u540D",
  "Last name": "\u59D3",
  "Role assignments": "\u89D2\u8272\u5206\u914D",
  "Assigned roles": "\u5DF2\u5206\u914D\u89D2\u8272",
  "Available roles": "\u53EF\u9009\u89D2\u8272",
  "Save user": "\u4FDD\u5B58\u7528\u6237",
  "Create role": "\u65B0\u5EFA\u89D2\u8272",
  "Edit role": "\u7F16\u8F91\u89D2\u8272",
  "Delete role": "\u5220\u9664\u89D2\u8272",
  "Search permissions": "\u641C\u7D22\u6743\u9650",
  "Select streams": "\u9009\u62E9\u65E5\u5FD7\u6D41",
  "All streams": "\u5168\u90E8\u65E5\u5FD7\u6D41",
  "No stream selected": "\u672A\u9009\u62E9\u65E5\u5FD7\u6D41",
  "You have no access to any stream": "\u4F60\u6CA1\u6709\u4EFB\u4F55\u65E5\u5FD7\u6D41\u7684\u8BBF\u95EE\u6743\u9650",
  "Loading streams": "\u6B63\u5728\u52A0\u8F7D\u65E5\u5FD7\u6D41",
  "Search filters": "\u641C\u7D22\u7B5B\u9009",
  "Add search filter": "\u6DFB\u52A0\u641C\u7D22\u7B5B\u9009",
  "Query string": "\u67E5\u8BE2\u8BED\u53E5",
  "Search query": "\u641C\u7D22\u67E5\u8BE2",
  "Execute": "\u6267\u884C",
  "Clear": "\u6E05\u7A7A",
  "Reset search": "\u91CD\u7F6E\u641C\u7D22",
  "Unsaved changes": "\u6709\u672A\u4FDD\u5B58\u7684\u4FEE\u6539",
  "Discard changes": "\u653E\u5F03\u4FEE\u6539",
  "Keep editing": "\u7EE7\u7EED\u7F16\u8F91",
  "Leave page": "\u79BB\u5F00\u9875\u9762",
  "Stay on page": "\u7559\u5728\u672C\u9875",
  "Something went wrong": "\u51FA\u73B0\u9519\u8BEF",
  "An error occurred": "\u53D1\u751F\u9519\u8BEF",
  "Server not available": "\u670D\u52A1\u5668\u4E0D\u53EF\u7528",
  "Could not reach server": "\u65E0\u6CD5\u8FDE\u63A5\u670D\u52A1\u5668",
  "Retry connection": "\u91CD\u65B0\u8FDE\u63A5",
  "Sign in failed": "\u767B\u5F55\u5931\u8D25",
  "Invalid credentials": "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
  "Login with default method": "\u4F7F\u7528\u9ED8\u8BA4\u65B9\u5F0F\u767B\u5F55",
  "There are no messages to display": "\u6CA1\u6709\u53EF\u663E\u793A\u7684\u6D88\u606F",
  "No message available": "\u6CA1\u6709\u6D88\u606F",
  "Click to expand": "\u70B9\u51FB\u5C55\u5F00",
  "Click to collapse": "\u70B9\u51FB\u6536\u8D77",
  "Show all fields": "\u663E\u793A\u5168\u90E8\u5B57\u6BB5",
  "Only show highlighted fields": "\u53EA\u663E\u793A\u9AD8\u4EAE\u5B57\u6BB5",
  "Decorate": "\u88C5\u9970",
  "Highlight": "\u9AD8\u4EAE",
  "Pin": "\u56FA\u5B9A",
  "Unpin": "\u53D6\u6D88\u56FA\u5B9A",
  "Favorite": "\u6536\u85CF",
  "Unfavorite": "\u53D6\u6D88\u6536\u85CF",
  "Favorites": "\u6536\u85CF",
  "Recent": "\u6700\u8FD1",
  "Last opened": "\u6700\u8FD1\u6253\u5F00",
  "You do not have opened any searches/dashboards yet.": "\u4F60\u8FD8\u6CA1\u6709\u6253\u5F00\u8FC7\u641C\u7D22\u6216\u4EEA\u8868\u76D8\u3002",
  "You do not have any favorite items yet.": "\u4F60\u8FD8\u6CA1\u6709\u4EFB\u4F55\u6536\u85CF\u3002",
  "There is no recent activity yet.": "\u8FD8\u6CA1\u6709\u6700\u8FD1\u52A8\u6001\u3002",
  "Make any Search or Dashboard favorite to show up here.": "\u628A\u641C\u7D22\u6216\u4EEA\u8868\u76D8\u6807\u4E3A\u6536\u85CF\u540E\u4F1A\u663E\u793A\u5728\u8FD9\u91CC\u3002",
  "From now on, whenever you open a saved search/dashboard, it will show up here. In the meantime, you can start a new Search or Dashboard.": "\u4E4B\u540E\u4F60\u6253\u5F00\u5DF2\u4FDD\u5B58\u7684\u641C\u7D22\u6216\u4EEA\u8868\u76D8\uFF0C\u4F1A\u51FA\u73B0\u5728\u8FD9\u91CC\u3002\u73B0\u5728\u53EF\u4EE5\u65B0\u5EFA\u4E00\u4E2A\u641C\u7D22\u6216\u4EEA\u8868\u76D8\u3002",
  "Whenever any other user will update content you have access to, or share new content with you, it will show up here.": "\u5176\u4ED6\u7528\u6237\u66F4\u65B0\u4F60\u80FD\u8BBF\u95EE\u7684\u5185\u5BB9\uFF0C\u6216\u628A\u65B0\u5185\u5BB9\u5206\u4EAB\u7ED9\u4F60\u65F6\uFF0C\u4F1A\u51FA\u73B0\u5728\u8FD9\u91CC\u3002",
  "This is your personal page, allowing easy access to the content most relevant for you.": "\u8FD9\u662F\u4F60\u7684\u4E2A\u4EBA\u9875\uFF0C\u7528\u6765\u5FEB\u901F\u6253\u5F00\u548C\u4F60\u6700\u76F8\u5173\u7684\u5185\u5BB9\u3002",
  "Overview of recently visited saved searches and dashboards.": "\u6700\u8FD1\u6253\u5F00\u7684\u5DF2\u4FDD\u5B58\u641C\u7D22\u548C\u4EEA\u8868\u76D8\u3002",
  "Overview of your favorite saved searches and dashboards.": "\u4F60\u6536\u85CF\u7684\u5DF2\u4FDD\u5B58\u641C\u7D22\u548C\u4EEA\u8868\u76D8\u3002",
  "This list includes all actions Graylog users performed, like creating or sharing an entity.": "\u8FD9\u91CC\u5217\u51FA\u7528\u6237\u521B\u5EFA\u6216\u5206\u4EAB\u5185\u5BB9\u7B49\u64CD\u4F5C\u3002",
  "Announcing Graylog": "Graylog \u516C\u544A"
};
export default ZH;
